import { weekDayMonthDate, isToday } from "./dateHelpers"

const FORM_SUBMISSION_AUDIT_TYPE = "FORM_SUBMISSION_AUDIT_TYPE"
const TASK_AUDIT_TYPE = "TASK_AUDIT_TYPE"
const CONVERSATION_AUDIT_TYPE = "CONVERSATION_AUDIT_TYPE"
const RESOLUTION_AUDIT_TYPE = "RESOLUTION_AUDIT_TYPE"

/* eslint-disable max-len */
// Property names match return values from auditTypeCanonicalName()
const AUDIT_DATA = {
  "formsubmission-create": {
    auditItemDetailsComponent: (view) => view.FormSubmissionCreatedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmission-edited": {
    auditItemDetailsComponent: (view) => view.FormSubmissionEditedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmission-export": {
    auditItemDetailsComponent: (view) => view.FormSubmissionExportedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmission-export-formsubmissionreport": {
    auditItemDetailsComponent: (view) => view.FormSubmissionExportedInFormSubmissionReportAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmission-export-solutionlevelreport": {
    auditItemDetailsComponent: (view) => view.FormSubmissionExportedInSolutionLevelReportAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmission-export-surveyreport": {
    auditItemDetailsComponent: (view) => view.FormSubmissionExportedInSurveyReportAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmission-form_submission_email_sent": {
    auditItemDetailsComponent: (view) => view.FormSubmissionEmailSentAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmission-form_type_change": {
    auditItemDetailsComponent: (view) => view.FormSubmissionFormTypeChangedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmission-update": {
    auditItemDetailsComponent: (view) => view.FormSubmissionUpdatedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmission-view": {
    auditItemDetailsComponent: (view) => view.FormSubmissionViewedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmission-workflow_failure-workflow": {
    auditItemDetailsComponent: (view) => view.FormSubmissionWorkflowFailedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "task-answered": {
    auditItemDetailsComponent: (view) => view.TaskAnsweredAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-answered-formsubmission": {
    auditItemDetailsComponent: (view) => view.TaskAnsweredAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-create": {
    auditItemDetailsComponent: (view) => view.TaskCreatedAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-create-formsubmission": {
    auditItemDetailsComponent: (view) => view.TaskCreatedAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-export-formsubmission": {
    auditItemDetailsComponent: (view) => view.TaskExportedInFormSubmissionAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-export-formsubmissionreport": {
    auditItemDetailsComponent: (view) => view.TaskExportedInFormSubmissionReportAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-export-solutionlevelreport": {
    auditItemDetailsComponent: (view) => view.TaskExportedInSolutionLevelReportAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-export-taskreport": {
    auditItemDetailsComponent: (view) => view.TaskExportedInTaskReportAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-task_email_sent-formsubmission": {
    auditItemDetailsComponent: (view) => view.TaskEmailSentAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-update": {
    auditItemDetailsComponent: (view) => view.TaskUpdatedAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-update-formsubmission": {
    auditItemDetailsComponent: (view) => view.TaskUpdatedAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-view": {
    auditItemDetailsComponent: (view) => view.TaskViewedAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "task-view-formsubmission": {
    auditItemDetailsComponent: (view) => view.TaskViewedAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "taskuser-create-task": {
    auditItemDetailsComponent: (view) => view.TaskUserCreatedAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "taskuser-destroy-task": {
    auditItemDetailsComponent: (view) => view.TaskUserRemovedAuditItemDetails,
    auditType: TASK_AUDIT_TYPE,
  },
  "accesslevelgrant-access_level_grant_access_level_change-formsubmission": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantAccessLevelChangedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "accesslevelgrant-create-formsubmission": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantCreatedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "accesslevelgrant-destroy-formsubmission": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantRemovedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "accesslevelgrant-update-formsubmission": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantUpdatedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "accesslevelgrant-access_level_grant_access_level_change-form": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantAccessLevelChangedAuditItemDetails,
  },
  "accesslevelgrant-create-form": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantCreatedAuditItemDetails,
  },
  "accesslevelgrant-destroy-form": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantRemovedAuditItemDetails,
  },
  "accesslevelgrant-update-form": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantUpdatedAuditItemDetails,
  },
  "accesslevelgrant-access_level_grant_access_level_change-category": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantAccessLevelChangedAuditItemDetails,
  },
  "accesslevelgrant-create-category": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantCreatedAuditItemDetails,
  },
  "accesslevelgrant-destroy-category": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantRemovedAuditItemDetails,
  },
  "accesslevelgrant-update-category": {
    auditItemDetailsComponent: (view) => view.AccessLevelGrantUpdatedAuditItemDetails,
  },
  "activestorage::attachment-create-formsubmission": {
    auditItemDetailsComponent: (view) => view.AttachmentCreatedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "activestorage::attachment-attachment_download-formsubmission": {
    auditItemDetailsComponent: (view) => view.AttachmentDownloadedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "activestorage::attachment-create-reportexport": {
    auditItemDetailsComponent: (view) => view.ReportExportAuditItemDetails,
  },
  "activestorage::attachment-create-taskreportexport": {
    auditItemDetailsComponent: (view) => view.ReportExportAuditItemDetails,
  },
  "activestorage::attachment-destroy-formsubmission": {
    auditItemDetailsComponent: (view) => view.AttachmentRemovedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmissionrelationship-create-formsubmission": {
    auditItemDetailsComponent: (view) => view.RelatedFormSubmissionCreatedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "formsubmissionrelationship-update-formsubmission": {
    auditItemDetailsComponent: (view) => view.RelatedFormSubmissionUpdatedAuditItemDetails,
    auditType: FORM_SUBMISSION_AUDIT_TYPE,
  },
  "facility-create": {
    auditItemDetailsComponent: (view) => view.FacilityCreated,
  },
  "facility-update": {
    auditItemDetailsComponent: (view) => view.FacilityUpdated,
  },
  "department-create-facility": {
    auditItemDetailsComponent: (view) => view.DepartmentCreated,
  },
  "department-update-facility": {
    auditItemDetailsComponent: (view) => view.DepartmentUpdated,
  },
  "departmentmembership-create-department": {
    auditItemDetailsComponent: (view) => view.DepartmentMembershipCreated,
  },
  "departmentmembership-destroy-department": {
    auditItemDetailsComponent: (view) => view.DepartmentMembershipDestroyed,
  },
  "departmentmembership-update-department": {
    auditItemDetailsComponent: (view) => view.DepartmentMembershipUpdated,
  },
  "conversation-create-formsubmission": {
    auditItemDetailsComponent: (view) => view.ConversationCreatedAuditItemDetails,
    auditType: CONVERSATION_AUDIT_TYPE,
  },
  "conversation-close-formsubmission": {
    auditItemDetailsComponent: (view) => view.ConversationClosedAuditItemDetails,
    auditType: CONVERSATION_AUDIT_TYPE,
  },
  "conversation-reopen-formsubmission": {
    auditItemDetailsComponent: (view) => view.ConversationReopenedAuditItemDetails,
    auditType: CONVERSATION_AUDIT_TYPE,
  },
  "conversation-export-formsubmission": {
    auditItemDetailsComponent: (view) => view.ConversationExportedInFormSubmissionAuditItemDetails,
    auditType: CONVERSATION_AUDIT_TYPE,
  },
  "message-create-formsubmission": {
    auditItemDetailsComponent: (view) => view.MessageCreatedAuditItemDetails,
    auditType: CONVERSATION_AUDIT_TYPE,
  },
  "resolution-create-formsubmission": {
    auditItemDetailsComponent: (view) => view.ResolutionCreatedAuditItemDetails,
    auditType: RESOLUTION_AUDIT_TYPE,
  },
  "resolution-update-formsubmission": {
    auditItemDetailsComponent: (view) => view.ResolutionUpdatedAuditItemDetails,
    auditType: RESOLUTION_AUDIT_TYPE,
  },
  "resolution-destroy-formsubmission": {
    auditItemDetailsComponent: (view) => view.ResolutionDeletedAuditItemDetails,
    auditType: RESOLUTION_AUDIT_TYPE,
  },
  "resolution-export-formsubmission": {
    auditItemDetailsComponent: (view) => view.ResolutionExportedInformSubmissionAuditItemDetails,
    auditType: RESOLUTION_AUDIT_TYPE,
  },
  "resolution-view-formsubmission": {
    auditItemDetailsComponent: (view) => view.ResolutionViewedAuditItemDetails,
    auditType: RESOLUTION_AUDIT_TYPE,
  },
}
/* eslint-enable max-len */

export const auditTypeCanonicalName = (audit) => {
  const {
    action, auditableType, associatedType, auditableDeleted, associatedDeleted,
  } = audit

  if (auditableDeleted || associatedDeleted) {
    return ""
  }

  return (
    `${auditableType}-${action}${associatedType ? `-${associatedType}` : ""}`.toLowerCase()
  )
}

export const groupAudit = (audits) => audits.reduce(
  (acc, audit) => {
    const formattedDate = weekDayMonthDate(audit.createdAt)
    if (isToday(audit.createdAt)) {
      if (acc.Today) {
        acc.Today.push(audit)
      } else {
        acc.Today = [audit]
      }
    } else if (acc[formattedDate]) {
      acc[formattedDate].push(audit)
    } else {
      acc[formattedDate] = [audit]
    }
    return acc
  },
  {},
)

export const auditItemDetailsComponent = (audit, view) => (
  AUDIT_DATA[auditTypeCanonicalName(audit)]?.auditItemDetailsComponent(view) || view.FallbackAuditItemDetails
)

export const auditForFormSubmission = (audit) => (
  AUDIT_DATA[auditTypeCanonicalName(audit)]?.auditType === FORM_SUBMISSION_AUDIT_TYPE
)

export const auditForATask = (audit) => (
  AUDIT_DATA[auditTypeCanonicalName(audit)]?.auditType === TASK_AUDIT_TYPE
)

export const auditForAConversation = (audit) => (
  AUDIT_DATA[auditTypeCanonicalName(audit)]?.auditType === CONVERSATION_AUDIT_TYPE
)

export const auditForAResolution = (audit) => (
  AUDIT_DATA[auditTypeCanonicalName(audit)]?.auditType === RESOLUTION_AUDIT_TYPE
)
